import React from 'lib/react';
import ReactDOMServer from 'react-dom/server';
import MapPin from './MapPin.component';
import { addDragEventsToPin } from './HtmlPushpinLayerEvents';
import { EVENTS } from '../BingMap.constants';

/**
 * A class for creating HTML pin elements
 * #genai
 * @param {Number} index
 * @param {Object} mapPoint
 * @param {Object} options
 * @param {String} options.propertyType
 * @param {Bool} options.isComplex
 * @param {Function} options.handleDeletePin
 * @param {Function} options.handleFocusChange - function to set focussed pin
 * @param {Number} options.focusedPinIndex - index of the focused map pin
 * @param {Bool} options.pinDragEnabled - whether or not pins can be added, deleted, and moved
 * @param {Object} options.colors
 * @param {Function} options.handleFetchPinAddress
 */
export default function HtmlPushpin(index, mapPoint, options) {
  const {
    propertyType,
    isComplex,
    handleDeletePin,
    handleFocusChange,
    focusedPinIndex,
    pinDragEnabled,
    colors,
    handleFetchPinAddress,
  } = options;
  this.index = index;
  const { address, building } = mapPoint;
  const { latitude, longitude } = address;
  this.location = { latitude, longitude };

  const htmlTemplate = ReactDOMServer.renderToStaticMarkup(
    <MapPin
      isComplex={isComplex}
      pinIndex={index}
      buildingID={building}
      address={address}
      propertyType={propertyType}
      focusedPinIndex={focusedPinIndex}
      pinDragEnabled={pinDragEnabled}
      colors={colors}
    />,
  );

  // Create the pushpins DOM element.
  this.element = document.createElement('div');
  this.element.innerHTML = htmlTemplate;
  this.element.style.position = 'absolute';
  this.element.style.transform = 'translate(-50%, -100%)';

  // Add click event on pin to change focused pin
  this.element.addEventListener(EVENTS.CLICK, handleFocusChange);
  this.element.addEventListener(EVENTS.TOUCHEND, handleFocusChange);

  // Add delete events to delete button in pin element
  const deleteBtn = this.element.querySelector(`#addressDeleteBtn-${index}`);
  const handleDelete = (e) => {
    e.stopPropagation();
    handleDeletePin(index);
  };
  if (deleteBtn) {
    deleteBtn.addEventListener(EVENTS.CLICK, handleDelete);
    deleteBtn.addEventListener(EVENTS.TOUCHEND, handleDelete);
    deleteBtn.addEventListener(EVENTS.MOUSEDOWN, (e) => e.stopPropagation());
    deleteBtn.addEventListener(EVENTS.MOUSEUP, (e) => e.stopPropagation());
  }

  // Add fetch address event to try again button in pin element
  const tryAgainBtn = this.element.querySelector(`#tryAgain-${index}`);
  const handleFetchAddress = (e) => {
    e.stopPropagation();
    handleFetchPinAddress(index);
  };
  if (tryAgainBtn) {
    tryAgainBtn.addEventListener(EVENTS.CLICK, handleFetchAddress);
    tryAgainBtn.addEventListener(EVENTS.TOUCHEND, handleFetchAddress);
    tryAgainBtn.addEventListener(EVENTS.MOUSEDOWN, (e) => e.stopPropagation());
    tryAgainBtn.addEventListener(EVENTS.MOUSEUP, (e) => e.stopPropagation());
  }
  if (pinDragEnabled) addDragEventsToPin(this);
}
